import React from "react";
import "../../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import "../../Coporate-travel-management/EmpoweringSection/Empowering.css";
import BannerWrapper from "../../../commonComponents/BannerWrapper";

const BliesureBanner = ({ onLoad }) => {
  return (
    <>
      <BannerWrapper onLoad={onLoad}>
        {({ useHighRes, imageLoaded, handleImageLoad }) => (
          <>
            <div
              className="container-fluid ctm-banner position-relative p-0"
              style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
            >
              <img
                src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/5.%20Luxury%20Travel.webp"
                alt="Luxury Travel"
                className="w-100"
                loading={useHighRes ? "eager" : "lazy"}
                onLoad={handleImageLoad}
                fetchpriority={useHighRes ? "high" : "auto"}
              />
              {imageLoaded ? (
                <div className="ctm-text position-absolute text-white mt-md-5 mt-3">
                  <p className="fs4 text-uppercase busy">BLEISURE TRAVEL</p>
                  <h1 className="banner-headings">
                    Merging Business with Relaxation
                  </h1>
                  <div className="d-flex common-second-content">
                    <div className="ornge-border"></div>
                    <div className="second-content">
                      Who said work can’t come with a view? Upgrade your
                      business trips with premium stays, breathtaking
                      destinations, and the perfect work-play blend.
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            {imageLoaded ? (
              <div className="container EmpoweringSection">
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex justify-content-center align-items-center flex-column">
                      <h1 className="headings">
                        <span>Experience BLeisure </span> Delight with Blueberry
                        Travels
                      </h1>
                      <p className="firstPara mt-2 mt-md-4 pe-2">
                        Enjoy the perfect blend of business and leisure with our
                        premium BLeisure Travel services. At Blueberry Travel,
                        we understand the unique needs of corporate travelers
                        who seek to maximize productivity without sacrificing
                        relaxation. Whether it’s about extending your stay for a
                        weekend getaway or relaxing between meetings, we ensure
                        your travel is both pleasant and efficient.
                      </p>
                      <p className="secondPara pe-2">
                        Let Blueberry handle all the details, from personalized
                        itineraries to exclusive activities, so you can focus on
                        what truly matters to you—your business. Enhance your
                        corporate travel with our Bleisure offerings!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </>
        )}
      </BannerWrapper>
    </>
  );
};

export default BliesureBanner;
